export default __webpack_public_path__ + "static/media/laundry2-after-1920w.aa1f1a7c.webp";